import React, { useEffect } from 'react';
import { ROUTE } from 'client_react/booking/common';
import { useClientBookingExperience } from './ClientBookingExperience';
import ConfirmationContent from './components/ConfirmationContent';

const ConfirmationPage = () => {
    const {
        bookingSession,
        bookingSessionType,
        contract,
        isPending,
        navigateWithSession,
        getContract
    } = useClientBookingExperience();

    useEffect(() => {
        if (isPending) {
            return;
        }

        if (bookingSession && bookingSession.isIncomplete) {
            navigateWithSession(ROUTE.CONTACT_INFORMATION);
        }
    }, [bookingSession, isPending, navigateWithSession]);

    // Refetch contract when page loads to ensure we have the latest status
    useEffect(() => {
        if (bookingSession?.contractId && bookingSession?.contactEmail) {
            getContract({
                search: { email: bookingSession.contactEmail },
                url: bookingSession.contractId
            });
        }
    }, [bookingSession?.contractId, bookingSession?.contactEmail, getContract]);

    const handleViewContract = () => {
        // Navigate to the standalone contract view instead of the booking flow contract page
        // This ensures the client can properly sign the contract
        if (contract?.publicId) {
            window.location.href = `/contract/${contract.publicId}/view`;
        } else {
            // Fallback to the booking flow contract page if no publicId is available
            navigateWithSession(ROUTE.CONTRACT_CONFIRMATION);
        }
    };

    if (!bookingSession && !bookingSessionType) {
        return null;
    }

    return (
        <ConfirmationContent
            bookingSession={bookingSession}
            bookingSessionType={bookingSessionType}
            showSubtitle
            contract={contract}
            onViewContract={handleViewContract}
        />
    );
};

export default ConfirmationPage;
